import {map, Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {SearchMatchPlayerWs} from "@app/core/match-player/data/network/search-match-player.ws";
import {MatchPlayer} from "@app/core/match-player/domain/model/match-player";
import {MatchPlayerMapper} from "@app/core/match-player/data/network/match-player.mapper";
import {MatchPlayerRepo} from "@app/core/match-player/domain/match-player.repo";

@Injectable()
export class MatchPlayerDataRepo implements MatchPlayerRepo {

    constructor(
        private searchMatchPlayer: SearchMatchPlayerWs,
    ) {
    }

    searchUsers(email: string): Observable<MatchPlayer[]> {
        return this.searchMatchPlayer.fetch(email).pipe(
            map(response => response.map(MatchPlayerMapper.deserialize))
        )
    }
}
